var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSortDurationShortToLong({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H6v2h6V3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10a3 3 0 0 1 3 3H9v-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 20A7 7 0 1 0 9 6a7 7 0 0 0 0 14Zm0-2A5 5 0 1 0 9 8a5 5 0 0 0 0 10Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22 16-3 4-3-4h2V6h2v10h2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSortDurationShortToLong);
export default __webpack_public_path__ + "static/media/ic_action_sort_duration_short_to_long.9d11406338d356b74c8a1cffb789e082.svg";
export { ForwardRef as ReactComponent };